import React from "react";
import WatchBoard from "@/components/WatchBoard";
import { boardShape } from "@/lib/boardShapes";

// The boards a player picks from before any game (Jack, 2026-10-12: every
// game starts with a board pick), with a short write-up of each (Jack,
// 2026-10-16). Classic is listed first.
export const BOARD_CHOICES = [
  {
    id: "boardgame3", name: "Classic", letter: "C",
    blurb: "The standard board. Green and Grey POW squares to blow up tiles, Connector Tiles in your bag, no gems. The best place to start.",
  },
  {
    id: "boardgame2", name: "Fortress", letter: "F",
    blurb: "Classic plus 8 gem squares. Land on a gem to earn a wall tile POW can't blow up. Collect all 4 on your side for 2 bonus walls.",
  },
  // Fortress 2.0 (Jack, 2026-10-28): no grey POWs, 10-tile hands, POW bonus.
  {
    id: "fortress2", name: "Fortress 2.0", letter: "F",
    blurb: "Fortress with no grey POW squares and 10 tiles a turn. Land on all 3 green POW squares on your side for 2 bonus POW cards. Gems and Fortress pro as on Fortress.",
  },
  // Infinity (Jack, 2026-10-29): Fortress 2.0 with centre walls and joined sides.
  {
    id: "infinity2", name: "Infinity", letter: "I",
    blurb: "Fortress 2.0 with 5 walls across the middle and a wall in each corner, and the sides are joined: a word that runs off one edge carries on from the other edge on the same row.",
  },
  {
    id: "firefly2", name: "Firefly", letter: "F",
    blurb: "A longer board with walls already in front of each base. 9 gem squares to earn wall tiles and 10 Green POW squares round the edges.",
  },
  {
    id: "boardgame5", name: "The Wave", letter: "W",
    blurb: "A longer board with wedges of wall down both sides, leaving a channel that narrows toward each base. 9 gem squares and 8 Green POW squares.",
  },
  // Bridges (Jack, 2026-10-27): the river version, layout key bridges2 (two
  // more rows each side of the river than bridges_trial). The earlier
  // Bridges boards (bridges, bridges_trial) are hidden; their games still load.
  {
    id: "bridges2", name: "Bridges", letter: "B",
    blurb: "A narrow board with a river across the middle. Land on your 3 yellow squares to earn bridge tiles, lay one on the river, and build straight over it. Land on both green POW squares on your side for 2 bonus POW cards. 10 tiles a turn, 5 wall tiles to start.",
  },
  // Bridges 2.0 (Jack, 2026-10-29): Bridges with a row of sand each side of
  // the river; wall tiles go anywhere on your side except the sand.
  {
    id: "bridges3", name: "Bridges 2.0", letter: "B",
    blurb: "Bridges with a row of sand on each side of the river. Letters can go on the sand. Wall tiles can go anywhere on your side of the river, but not on the sand. Yellow squares, bridge tiles and the POW bonus work as on Bridges.",
  },
];

// One tappable card per board: a picture of the board (Jack, 2026-10-27,
// in place of its letter), name and write-up. `onPick(id)` is
// called when a board is tapped; `selected` highlights one.
export default function BoardChoice({ onPick, selected, disabled, testIdPrefix = "board" }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {BOARD_CHOICES.map((b) => (
        <button
          key={b.id}
          type="button"
          disabled={disabled}
          onClick={() => onPick(b.id)}
          className={`text-left rounded-xl border p-3 transition-colors disabled:opacity-50 disabled:cursor-wait ${
            selected === b.id ? "border-brand bg-brand/10" : "border-border bg-background hover:border-brand/60 hover:bg-brand/5"
          }`}
          data-testid={`${testIdPrefix}-${b.id}`}
        >
          <div className="flex items-start gap-2.5">
            <div className="flex-none w-16" aria-hidden="true">
              <WatchBoard shape={boardShape(b.id)} tiles={{}} letters={false} />
            </div>
            <div className="min-w-0">
              <div className="font-display font-bold text-sm">{b.name}</div>
              <div className="text-[12px] text-muted-foreground leading-snug mt-0.5">{b.blurb}</div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
